import React, { useState } from "react";
import LmsTable from "../ui/LmsTable";
import { useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { GlobalConstants } from "../../constants/GlobalConstants";
import { FeatureFlags } from "../../constants/LocalServerConstants";

const SystemsLoanCommentsMainTable = () => {
  const actionsButtons = ["add", "remove", { text: "Add to Multiple Loans", action: "add", path: "systems-loan-comments/add-to-multiple" }];

  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="" // TODO: Add table suffix
    sortable={["Created On"]}
  />;
};

const AddSystemsLoanCommentForm = () => {
  const myForm = new BCFormController({}, { submitSuffix: "" }); // TODO: Add submit suffix
  myForm.addGroupFields([
    myForm.getDropdownField("Borrower", "metadata/list-borrower-organizations", { required: true }),
    myForm.getDropdownField("Special Purpose Entity", "orgs/list-spes"),
    myForm.getInputField("Application #"),
    myForm.getInputField("Loan #"),
    myForm.getDropdownField("Project Name", ""),
  ]);
  myForm.addCenteredGroup([myForm.getDropdownField("Category", "loandetails/list-comment-categories", { name: "commentCategoryId", required: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Comment Subject", "metadata/list-comment-subjects", { required: true, dependencyField: "commentCategoryId" })]);
  myForm.addCenteredGroup([myForm.getTextareaField("Comments")]);
  myForm.addCenteredGroup([myForm.getCheckboxField("Generate Email?", { name: "generateEmail" })]);

  return <LmsFormGenerator myForm={myForm} actions={["save", "close"]}/>;
};

const AddLoanCommentToMultipleForm = () => {
  const [selectedLoans, setSelectedLoans] = useState([] as any[]);
  const myForm = new BCFormController({}, { submitSuffix: "" }); // TODO: Add submit suffix
  myForm.addCenteredGroup([myForm.getDisplayField("Loans")]);
  myForm.addCenteredGroup([myForm.getDropdownField("Category", "", { required: true })]);
  myForm.addCenteredGroup([myForm.getDropdownField("Comment Subject", "", { required: true })]);
  myForm.addCenteredGroup([myForm.getTextareaField("Comments")]);
  myForm.addCenteredGroup([myForm.getCheckboxField("Generate Email?")]);

  const handleContinue = (data) => {
    if (FeatureFlags.IS_DEBUG) {
      setSelectedLoans([...data?.getCheckedIds()]);
    }
  };

  const actionButtons = [{ text: "Continue", icon: GlobalConstants.Icons.CARET_UP, handleClick: handleContinue, isDisabled: (checkedItems) => checkedItems?.length > 0 }, "close"];

  return <React.Fragment>
    {selectedLoans.length === 0 && <LmsTable actionButtons={actionButtons}/>}
    {selectedLoans.length > 0 && <LmsFormGenerator myForm={myForm} actions={["save", "close"]}/>}
  </React.Fragment>;
};

const LmsSystemsLoanComments = ({ params = {}, history }) => {
  const allowedActions = [];
  const allowedSubpages = ["add-to-multiple"];
  const { isMainPage, isAdd, isActionAllowed, isSubpageAllowed, actionLower } = useParseRouteActions(params, allowedActions, allowedSubpages);

  if (!isActionAllowed) {
    history.goBack();
  }

  return (<React.Fragment>
    {isMainPage && <SystemsLoanCommentsMainTable/>}
    {isAdd && <AddSystemsLoanCommentForm/>}
    {isSubpageAllowed && <React.Fragment>
      {actionLower === "add-to-multiple" && <AddLoanCommentToMultipleForm/>}
    </React.Fragment>}
  </React.Fragment>);
};

export default LmsSystemsLoanComments;